/** Port di ZionExpiry.kt — timer messaggio nel payload cifrato. */

const PREFIX_ABS = 'NYXIA_TTL::'
const PREFIX_VIEW_MS = 'NYXIA_TTL_VIEW::'

export interface IncomingExpiry {
  body: string
  expiresAt?: number
  viewTtlMs?: number
}

export function wrapWithViewTtl(text: string, ttlMs: number | null | undefined): string {
  if (ttlMs == null || ttlMs <= 0) return text
  return `${PREFIX_VIEW_MS}${ttlMs}::${text}`
}

export function ttlMsToDurationSeconds(ttlMs: number | null | undefined): number {
  if (ttlMs == null || ttlMs <= 0) return 0
  return Math.max(1, Math.ceil(ttlMs / 1000))
}

function resolveNyxiaViewTtl(raw: string): IncomingExpiry | null {
  if (!raw.startsWith(PREFIX_VIEW_MS)) return null
  const rest = raw.slice(PREFIX_VIEW_MS.length)
  const sep = rest.indexOf('::')
  if (sep <= 0) return { body: raw }
  const ttl = Number.parseInt(rest.slice(0, sep), 10)
  if (!Number.isFinite(ttl) || ttl <= 0) return { body: rest.slice(sep + 2) }
  return { body: rest.slice(sep + 2), viewTtlMs: ttl }
}

function resolveNyxiaAbsTtl(raw: string, now: number): IncomingExpiry | null {
  if (!raw.startsWith(PREFIX_ABS)) return null
  const rest = raw.slice(PREFIX_ABS.length)
  const sep = rest.indexOf('::')
  if (sep <= 0) return { body: raw }
  const exp = Number.parseInt(rest.slice(0, sep), 10)
  if (!Number.isFinite(exp) || exp <= 0) return { body: rest.slice(sep + 2) }
  if (exp <= now) return null
  return { body: rest.slice(sep + 2), expiresAt: exp }
}

export function resolveIncomingExpiry(raw: string, now = Date.now()): IncomingExpiry | null {
  const trimmed = raw.trim()
  if (!trimmed) return { body: trimmed }
  return resolveNyxiaViewTtl(trimmed) ?? resolveNyxiaAbsTtl(trimmed, now) ?? { body: trimmed }
}
